import React, { ReactElement, useState } from 'react'
import {
  docExampleMobile,
  ids,
  logo,
  switchIcon,
} from '../assets/images/images'
import ModalContainer from './Modal/ModalContainer'
import Logout from './Modal/Logout'
import kycCore from '../services/Kyc'

function Header({
  isLogoutButtonVisible = true,
}: {
  isLogoutButtonVisible?: boolean
}): ReactElement {
  const [modalOpen, setModalOpen] = useState(false)
  const logout = () => {
    kycCore.auth.logout()
    window.location.assign('https://www.louvrebanqueprivee.fr/')
  }

  return (
    <header className="navbar flexShrink0">
      <div className="containerFluid">
        <nav className="navbarNav justifyContentBetween">
          <span className="navbarBrand">
            <img src={logo} className="dBlock mt03 mb05" alt="Logo" />
          </span>
          {isLogoutButtonVisible && (
            <button
              type="button"
              className="btn btnPrimary btnPrimarySm"
              onClick={() => setModalOpen(true)}
            >
              <img src={switchIcon} alt="Logout" className="dBlock" />
            </button>
          )}
        </nav>
        <img
          src={ids}
          alt="for caching only"
          width="0"
          height="0"
          className="hidden"
        />
        <img
          src={docExampleMobile}
          alt="for caching only"
          width="0"
          height="0"
          className="hidden"
        />
      </div>
      <ModalContainer isOpen={modalOpen}>
        <Logout
          onClose={() => setModalOpen(false)}
          onConfirm={() => logout()}
        />
      </ModalContainer>
    </header>
  )
}

export default Header
